import type { ReactNode } from "react";
import Button from "./Button";

export function LoadingState({ label = "Chargement des données..." }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-foreground-500" role="status">
      <span className="w-8 h-8 flex items-center justify-center animate-spin [animation-duration:700ms]" aria-hidden="true">
        <i className="ri-loader-4-line text-2xl text-primary-600"></i>
      </span>
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-accent-200 bg-accent-50/60 px-4 py-12 text-center" role="alert">
      <span className="w-11 h-11 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center">
        <i className="ri-error-warning-line text-2xl"></i>
      </span>
      <div>
        <p className="text-sm font-semibold text-foreground-900">Impossible de charger les données</p>
        <p className="mt-1 max-w-md text-sm text-foreground-600 break-words">{message}</p>
      </div>
      {onRetry && (
        <Button variant="outline" size="sm" icon="ri-refresh-line" onClick={onRetry}>
          Réessayer
        </Button>
      )}
    </div>
  );
}

interface EmptyStateProps {
  icon?: string;
  title: string;
  message?: string;
  action?: ReactNode;
}

export function EmptyState({ icon = "ri-inbox-line", title, message, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-background-300 bg-background-100/60 px-4 py-12 text-center">
      <span className="w-12 h-12 rounded-full bg-background-50 text-foreground-500 shadow-card flex items-center justify-center" aria-hidden="true">
        <i className={`${icon} text-2xl`}></i>
      </span>
      <div>
        <p className="text-sm font-semibold text-foreground-800">{title}</p>
        {message && <p className="mt-1 text-sm text-foreground-500 max-w-md mx-auto break-words">{message}</p>}
      </div>
      {action}
    </div>
  );
}